import { callGraphQL } from '../utils/request'
import type {
  TeamResponse,
  StandingsRes,
  GamedayTeamRoster,
  RostersResponse,
  AssistTrackerRes,
} from './team.types'
import {
  standingsQuery,
  teamAllDataQuery,
  teamMatchupsDataQuery,
  allGamedayRostersQuery,
  teamAssistTrackerDataQuery,
} from './team.queries'
import { champSeriesStatTitles, statTitles } from '../../Constant/player'

export async function fetchTeamAllDataGQL(
  teamId: string,
  infoYear: number,
  statsYear: number,
  eventsYear: number,
  includeCS: boolean = false
) {
  const leaderList = includeCS ? champSeriesStatTitles : statTitles
  try {
    const teamRes = await callGraphQL<TeamResponse>(teamAllDataQuery, {
      id: teamId,
      year: infoYear,
      statsYear,
      eventsYear,
      statList: leaderList,
      includeCS,
    })
    return teamRes?.team ?? null
  } catch (e) {
    console.error(e)
    return null
  }
}

export async function getTeamAndPlayerInfoStatsGQL(
  teamId: string,
  year: number,
  segment: string,
  statsYear: number,
  isChampSeries: boolean = false
) {
  try {
    const res = await callGraphQL<TeamResponse>(teamMatchupsDataQuery, {
      id: teamId,
      year,
      segment,
      statsYear,
      isChampSeries,
    })
    return res?.team ?? null
  } catch (e) {
    console.error(e)
    return null
  }
}

/**
 * Fetch all team game day rosters by a given week
 */
export const fetchAllGamedayRosters = async (
  year: number,
  week: number
): Promise<GamedayTeamRoster[]> => {
  try {
    const rosterRes = await callGraphQL<RostersResponse>(allGamedayRostersQuery, {
      year: year,
      week: week,
    })
    return rosterRes?.allGamedayRosters || []
  } catch (error) {
    return []
  }
}

export async function fetchStandings(year: number, champSeries: boolean = false) {
  try {
    const standingsRes = await callGraphQL<StandingsRes>(standingsQuery, {
      year: year,
      champSeries: champSeries,
    })
    return standingsRes?.standings ?? null
  } catch (error) {
    return null
  }
}

export async function fetchAssistTrackerByTeam(teamId: string, year: number) {
  try {
    const assistTrackerRes = await callGraphQL<AssistTrackerRes>(teamAssistTrackerDataQuery, {
      id: teamId,
      year: year,
    })
    return assistTrackerRes?.team ?? null
  } catch (error) {
    return null
  }
}
